import styles from './Readmore.css'
import { Icon } from '@vzmi/shp_shared_compo'

const Readmore = props => {
  const { href, text = '看更多排行', onClick } = props
  return (
    <section className={styles.Readmore}>
      <a
        href={href}
        onClick={onClick}
      >
        <span>{text}</span>
        <Icon
          color={'#5478fc'}
          name={'caret-right'}
          size={14}
        />
      </a>
    </section>
  )
}

export default Readmore
